// extracted by mini-css-extract-plugin
module.exports = {"host":"style_host__YgjPl"};